import { isEmail, isNumeric } from 'validator';

/*
  {
    // 必須為email格式
    emailTest: true,
    // 字元長度必須 >=
    lengthTest: 6,
    // 字串必須完全一致
    equalTest: 'this is sample'
  }
*/

export default function(value, ruleObj) {
  let resultObj = {};

  if(ruleObj.emailTest) resultObj.emailTest = isEmail(value);
  if(ruleObj.lengthTest) resultObj.lengthTest = value.length >= ruleObj.lengthTest;
  if(ruleObj.equalTest) resultObj.equalTest = value === ruleObj.equalTest;
  if(ruleObj.numberTest) resultObj.numberTest = isNumeric(value);

  return resultObj;

};


// WEBPACK FOOTER //
// ./src/commonJS/inputValidation.js